"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function abt(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
        React.createElement("path", { d: "M4.875 7.86525L12 3.75L19.125 7.86525V16.1348L12 20.25L4.875 16.1348V7.86525ZM5.559 15.3428L8.4165 13.689L9.86625 11.1502L5.559 8.658V15.3428ZM5.90175 15.936L11.6783 19.2728V16.08L8.64975 14.3453L5.90175 15.9352V15.936ZM18.441 8.68125L14.172 11.151L15.621 13.6875L18.441 15.3195V8.68125ZM18.1185 8.07525L12.3622 4.7505V7.98225L13.8323 10.5555L18.1185 8.07525ZM13.5833 11.4915L12.7042 12L14.448 13.0087L13.5833 11.4915ZM13.2435 10.896L12.3622 9.351V11.406L13.2435 10.896ZM9.5955 13.0072L11.3355 12L10.4587 11.493L9.59625 13.0072H9.5955ZM9.336 13.9493L11.6783 15.2902V12.594L9.336 13.9493ZM5.901 8.064L10.206 10.554L11.6783 7.97775V4.72725L5.901 8.064ZM18.1185 15.9247L15.3915 14.3468L12.3622 16.1025V19.2495L18.1185 15.9247ZM14.7075 13.9508L12.3622 12.594V15.3105L14.7075 13.95V13.9508ZM10.7985 10.8975L11.6783 11.406V9.35475L10.7985 10.8975Z", fill: color }));
}
exports["default"] = abt;
//# sourceMappingURL=abt.js.map